import type { Role } from '@/pages/users/types/rbac';

/**
 * Unify Admin–only System Integrations (email test). Matches assigned
 * `unify-admin` on the profile **or** the session display role. PractitionerRole-only
 * assignment is still authorized by the bot; UI `availableRoles` does not hydrate
 * PractitionerRole codes.
 */
export function canAccessSystemIntegrationsSettings(
  availableRoles: readonly string[],
  displayUserRole?: string,
): boolean {
  if (displayUserRole === 'Unify Admin') return true;
  return availableRoles.includes('unify-admin' satisfies Role);
}

/**
 * The `email-sender` `send-test-email` action runs only for a real Unify Admin (only that AccessPolicy grants
 * execute), so this checks the assigned slug, not the display role.
 */
export function canSendTestEmail(availableRoles: readonly string[]): boolean {
  return availableRoles.includes('unify-admin' satisfies Role);
}
